import { GridCellProps } from '@progress/kendo-react-grid';
import { StatusCircle } from 'src/components/shared/StatusCircle/StatusCircle';
import {
  isParameterCustomerOk,
  isParameterProductionOk
} from 'src/store/products/product.utils';
import { SpecificationDto } from 'src/store/specifications/specification';

type AnalysisStatusCircleCellProps = {
  value: Nullable<number>;
  specification?: Nullable<SpecificationDto>;
  exists?: boolean;
} & GridCellProps;

export const AnalysisStatusCircleCell = ({
  dataItem,
  value,
  specification,
  exists = true,
  className,
  style
}: AnalysisStatusCircleCellProps) => {
  let color;

  if (!exists) {
    color = 'var(--blue-status-color-rgb)';
  } else if (value === null || value === undefined) {
    color = 'var(--yellow-status-color-rgb)';
  } else if (
    isParameterProductionOk(value, dataItem) &&
    isParameterCustomerOk(value, dataItem) &&
    specification
  ) {
    color = 'var(--green-status-color-rgb)';
  } else {
    color = 'var(--red-status-color-rgb)';
  }

  return (
    <td className={className} style={{ ...style, textAlign: 'center' }}>
      <StatusCircle color={color} />
    </td>
  );
};
